




















































































import { computed, defineComponent, onMounted, watch, ref } from '@nuxtjs/composition-api';
import { ValidationObserver } from 'vee-validate';
import { useCartAttributes } from '~/features/cart';
import { useProductContext } from '~/features/productContext';

export default defineComponent({
  name: 'GiftCardForm',
  components: {
    ValidationObserver,
  },
  setup(_, { emit }) {
    const { items: cartItems } = useCartAttributes();
    const { product, appendProductValues } = useProductContext({
      init: true,
    });

    // disable the giftcard form if the gift card was in the cart.
    const disableMageWorxForm = computed(() => cartItems.value.some(e => e.sku === product.value.sku));

    const input = ref({
      giftCardToEmail: '',
      giftCardFromName: '',
      giftCardToName: '',
      giftCardMessage: '',
    });

    onMounted(() => {
      /**
       * look if the current product exists in the cart. if found there will be 2 scenarios
       * - the product is MageWorxGiftCards and it has a receiver email. which will be shown again
       * - the product is not MageWorxGiftCards, and doesn't have a receiver email
       */
      const findMageWorxItem = computed(() => cartItems.value.find(e => e.sku === product.value.sku));

      input.value = {
        giftCardToEmail: findMageWorxItem.value?.mageWorxFormData?.mail_to_email ?? '',
        giftCardFromName: findMageWorxItem.value?.mageWorxFormData?.mail_from ?? '',
        giftCardToName: findMageWorxItem.value?.mageWorxFormData?.mail_to ?? '',
        giftCardMessage: findMageWorxItem.value?.mageWorxFormData?.mail_message ?? '',
      };
    });

    watch(
      input,
      newValue => {
        appendProductValues({
          giftCardToEmail: newValue.giftCardToEmail,
          giftCardFromName: newValue.giftCardFromName,
          giftCardToName: newValue.giftCardToName,
          giftCardMessage: newValue.giftCardMessage,
        });

        emit('input', input.value);
      },
      { deep: true }
    );

    return {
      disableMageWorxForm,
      input,
    };
  },
});
